export default {
  selectedProductVariants: [],
  currentProductVariant: null,
  totalPrice: 0,
  __typename: 'Variants'
};
